import * as React from "react";

import { uniqueDropdownId } from "@1js/acui-common";

import {
  AppFlyoutAnchorProps,
  AppFlyoutAnchorState,
} from "./AppFlyoutAnchor.types";
import { useControlledContextualMenuByMenuButton } from "./useControlledContextualMenuByMenuButton";
import { useShadowRenderedMenu } from "./useShadowRenderedMenu";

export const useAppFlyoutAnchorState = (
  props: AppFlyoutAnchorProps,
  state: AppFlyoutAnchorState
): AppFlyoutAnchorState => {
  // Create an id that won't change later
  const flyoutDropdownId = React.useRef(uniqueDropdownId(props, props.id));
  useShadowRenderedMenu(
    { ...props, typeId: "Flyout" },
    state,
    flyoutDropdownId.current
  );

  useControlledContextualMenuByMenuButton(props, state);

  // Create menuHidden prop to pass to MenuButton
  // This is for styling, to know if the MenuButton should style in the "expanded" state
  state.menuButton.menuHidden = state.menu.hidden;

  return state;
};
